import { Button, Callout, SimpleMenu, Tooltip, useMenuState } from "@octopusdeploy/design-system-components";
import { Environment } from "@octopusdeploy/utilities";
import { useMemo } from "react";
import * as React from "react";
import type { ServerNodeCommsAddress } from "~/areas/infrastructure/components/MachineSettings/Endpoints/KubernetesAgent/ConfigurationDialog";
import { getBackendServerUrl } from "~/areas/infrastructure/components/MachineSettings/Endpoints/KubernetesAgent/configurationUtils";
type LocalDevServerUrlHelperProps = {
    onServerAddressesChanged: (serverUri: string, grpcUri: string, serverNodeCommsAddresses: ServerNodeCommsAddress[]) => void;
    serverNodeCommsAddresses: ServerNodeCommsAddress[];
};
export const LocalDevServerUrlHelper = (props: LocalDevServerUrlHelperProps) => {
    const [openMenu, menuState, buttonAriaAttributes] = useMenuState();
    const backendUrl = useMemo(() => new URL(getBackendServerUrl()), []);
    const isHaMode = props.serverNodeCommsAddresses.length > 1;
    //if this is not development mode, return nothing
    if (!Environment.isInDevelopmentMode()) {
        return null;
    }
    const updateAddresses = (type: "DockerDesktop" | "Kind" | "Minikube" | "Colima") => {
        let domain = "localhost";
        switch (type) {
            case "DockerDesktop":
                domain = "host.docker.internal";
                break;
            case "Kind":
                domain = "dockerhost.default.svc.cluster.local";
                break;
            case "Minikube":
                domain = "host.minikube.internal";
                break;
            case "Colima":
                domain = "host.lima.internal";
                break;
        }
        const serverUri = `${backendUrl.protocol}//${domain}:${backendUrl.port}/`;
        const grpcUri = `grpc://${domain}:8443`;
        if (isHaMode) {
            const updatedNodeAddresses = props.serverNodeCommsAddresses.map((node) => ({
                nodeName: node.nodeName,
                commsAddress: `http://${domain}:PORT/`,
            }));
            props.onServerAddressesChanged(serverUri, grpcUri, updatedNodeAddresses);
        }
        else {
            props.onServerAddressesChanged(serverUri, grpcUri, [{ nodeName: "", commsAddress: `http://${domain}:10943/` }]);
        }
    };
    return (<>
            <Tooltip content={"Click this if you're running a local K8s cluster and aren't sure how to make that work (dev only)."}>
                <>
                    <Button importance="secondary" label="DEV: Change Server URLs for a local cluster" onClick={openMenu} {...buttonAriaAttributes}/>
                    <SimpleMenu menuState={menuState} items={[
            {
                type: "button",
                label: "Docker Desktop",
                onClick: () => updateAddresses("DockerDesktop"),
            },
            {
                type: "button",
                label: "Kind",
                onClick: () => updateAddresses("Kind"),
            },
            {
                type: "button",
                label: "Minikube",
                onClick: () => updateAddresses("Minikube"),
            },
            {
                type: "button",
                label: "Colima",
                onClick: () => updateAddresses("Colima"),
            },
        ]} accessibleName={"LocalDevServerUrlButton"} compact={true}/>
                </>
            </Tooltip>
            {isHaMode && (<Callout type="information" title="HA Cluster Detected">
                    Selecting a local environment will pre-configure domains for all HA nodes (you'll just need to add port numbers on the HA Node Configuration page). Detected nodes:{" "}
                    {props.serverNodeCommsAddresses.map((addr) => addr.nodeName).join(", ")}
                </Callout>)}
        </>);
};
